import React, {useState} from 'react';
import {Button, Form} from "react-bootstrap";
import {SecondaryAuthorizationData, SecondaryIdentifier, sendDelete, sendOTP} from "./api";
import CurrentState from "./CurrentStateEnum";
import PropTypes, {InferProps} from 'prop-types';
import BackModal from "../Modal";
import {useTranslation} from "react-i18next";

export default function OTPForm({setCurrentState, setError, setRendering, renderError, renderSpinner, secondaryAuthorizationData, setSecondaryAuthorizationData }: InferProps<typeof OTPForm.propTypes>) {
    let secondaryAuthorization : SecondaryAuthorizationData = secondaryAuthorizationData;
    const [modalShow, setModalShow] = useState(false);

    const {t} = useTranslation();

    const change = (event: React.FormEvent<HTMLSelectElement>) => {
        let inputValue: string = event.currentTarget.value;

        if (!isNaN(Number(inputValue))) {
            setSecondaryAuthorizationData(
                {
                    account: secondaryAuthorization.account,
                    secondaryIdentifier: {
                        phoneNumber: secondaryAuthorization.secondaryIdentifier.phoneNumber,
                        email: secondaryAuthorization.secondaryIdentifier.email
                    } as SecondaryIdentifier,
                    oneTimePassword: inputValue
                } as SecondaryAuthorizationData
            );

        }
    };

    const submit = async (event: React.FormEvent<HTMLFormElement>) => {
        event.preventDefault();

        setRendering(true);

        const response = await sendOTP(secondaryAuthorization);

        if (response === null) {
            setError(t("helper.errorMessage"));
            setRendering(false);
        } else {
            if (response.errorMessage === null) {
                secondaryAuthorization.dueDate = response.dueDate;
                setSecondaryAuthorizationData(secondaryAuthorization);
                setCurrentState(CurrentState.Finished);
            } else {
                setError(t(response.errorMessage));
                setRendering(false);
            }
        }

    };

    return (
        <Form
            onSubmit={((event: React.FormEvent<HTMLFormElement>) => submit(event))}
        >
            {renderError()}
            <Form.Group controlId="oneTimePassword">
                <Form.Label>{t("otpForm.descriptionStart")} {secondaryAuthorization.secondaryIdentifier.email === "" ? t("otpForm.phone") : t("otpForm.email")} {t("otpForm.descriptionEnd")}</Form.Label>
                <Form.Control
                    minLength={6}
                    maxLength={6}
                    value={secondaryAuthorization.oneTimePassword}
                    onChange={(event) => change(event as any)}/>
            </Form.Group>

            <div className={"btn-group"}>
                <Button
                    onClick={() => setModalShow(true)}
                >
                    {t("helper.back")}
                </Button>
                <Button
                    type="submit">
                    {renderSpinner()}
                    {t("helper.next")}
                </Button>
            </div>


            <BackModal
                show={modalShow}
                onHide={()=> setModalShow(false)}
                onConfirm={async () => {
                    await sendDelete(secondaryAuthorizationData);

                    setCurrentState(CurrentState.SecondaryAuthForm);
                }}
                back={t("helper.cancel")}
                modalBody={t("modal.bodyOtp")}
                modalTitle={t("secondaryAuth.title")}
                yes={t("helper.yes")}
            />
        </Form>
    )
};

OTPForm.propTypes = {
    setCurrentState: PropTypes.func.isRequired,
    setError: PropTypes.func.isRequired,
    setRendering: PropTypes.func.isRequired,
    renderError: PropTypes.func.isRequired,
    renderSpinner: PropTypes.func.isRequired,
    secondaryAuthorizationData: PropTypes.any.isRequired,
    setSecondaryAuthorizationData: PropTypes.func.isRequired
};
